import { Box, useTheme, Typography } from "@mui/material";
import { tokens } from "../../theme";

import { useEffect, useState } from "react";
import { djangoApi } from "../../utils/axios/axios.utils";
import TableAcertosFuturos from "../../components/acertos-futuros";
import SkeletonTable from "./acertos-skeleton";

import { useDispatch, useSelector } from "react-redux";
import { selectSellers } from '../../store/sellers/sellers.selector'
import { setSellers } from '../../store/sellers/sellers.action'

const AcertosFuturosPage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [allKits, setAllKits] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    const dispatch = useDispatch();
    const sellersData = useSelector(selectSellers);

    useEffect(() => {
        const getSellersData = async () => {
            // setIsLoading(true)
            try {
                await djangoApi
                    .get("sellers/sellers/get_sellers", {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                    .then((res) => {
                        const { data, failure_payments } = res.data;
                        // setSellersData(data);
                        // console.log('sellers: ', data)
                        // console.log('failuure: ', failure_payments)

                        const kitsByUser = {};

                        if (Array.isArray(failure_payments)) {
                            failure_payments.forEach(kit => {
                                const sellerId = kit.seller__pk;
                                if (!kitsByUser[sellerId]) {
                                    kitsByUser[sellerId] = [];
                                }
                                kitsByUser[sellerId].push({
                                    ...kit
                                });
                            });
                        }

                        // Agora, adicionamos a propriedade 'kits_inadimplentes' em cada usuário
                        const unified = data.map(user => {
                            return {
                                ...user,
                                kits_inadimplentes: kitsByUser[user.id] || [],
                            };
                        });

                        // Resultado final:
                        // console.log('Unificado:', unified);
                        dispatch(setSellers(unified))
                        setIsLoading(false)
                    });
            } catch (err) {
                console.log("Erro ao alterar as aplicações", err);
                window.alert(err);
                // setIsLoading(false)
            } finally {
                console.log('finally here')
                // pass
                // setIsLoading(false)
            }
        };
        if (sellersData.length === 0) {
            console.log("consultando dados")
            getSellersData();
        } else {
            // setIsLoading(false)
        }
    }, []);

    const getProductsData = async () => {
        setIsLoading(true)
        try {
            await djangoApi
                .get("products/kits_active/get_all_open_kits/", {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log('resposeta', res.data)
                    const { data } = res.data;
                    setIsLoading(false)
                    setAllKits(data)
                    console.log('dados: ', data)
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    };

    useEffect(() => {
        const getProductsData = async () => {
            setIsLoading(true)
            try {
                await djangoApi
                    .get("products/kits_active/get_all_open_kits/", {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                    .then((res) => {
                        console.log('resposeta', res.data)
                        const { data } = res.data;
                        setIsLoading(false)
                        setAllKits(data)
                        console.log('dados: ', data)
                    });
            } catch (err) {
                console.log("Erro ao alterar as aplicações", err);
                window.alert(err);
                setIsLoading(false)
            } finally {
                // pass
                setIsLoading(false)
            }
        };
        getProductsData();
    }, []);

    return (
        <Box
            sx={{
                marginTop: '50px',
                padding: '10px'
            }}
        >
            {
                isLoading ?
                    <SkeletonTable />
                    :

                    <TableAcertosFuturos data={allKits} setAllKits={setAllKits}/>
            }
        </Box>
    );
}


export default AcertosFuturosPage;